import React from 'react';
import RenderPolygonBasedStatementDetails from 'utils/ocr-statement-details-utils';
import ElementDetailsOCR from './element-details-ocr';
import { hasAnnotations } from 'utils/ocr-annotation-utils';
import { useSelector } from 'react-redux';
import { areEqual } from 'constants/common/feature-common-utils';

// Memoized wrapper for individual elements
const ElementDetailsWrapper = React.memo(
  ({
    element,
    scale,
    BLOCK,
    markerDisplayValue,
    calloutDisplayValue,
    clearSelection,
    showElementStatusAndFlag,
    sectionId,
    isPreviewPage,
    isLeftView,
    canvasID,
    position,
    isCftEnabled,
  }) => {
    const { coordinatesInPixel } = element;

    let loopCount = null;

    if (hasAnnotations(element, isCftEnabled) || isPreviewPage) {
      switch (position) {
        case 'left':
        case 'top':
          loopCount = 0;
          break;
        case 'right':
        case 'bottom':
          loopCount = coordinatesInPixel.length - 1;
          break;
        default:
          loopCount = 0;
          break;
      }
    }
    return (
      <RenderPolygonBasedStatementDetails
        coordinates={coordinatesInPixel}
        scale={scale}
        key={element.id}
        loopCount={loopCount}
      >
        <ElementDetailsOCR
          element={element}
          BLOCK={BLOCK}
          markerDisplayValue={markerDisplayValue}
          calloutDisplayValue={calloutDisplayValue}
          clearSelection={clearSelection}
          showElementStatusAndFlag={showElementStatusAndFlag}
          sectionId={sectionId}
          isPreviewPage={isPreviewPage}
          isLeftView={isLeftView}
          canvasID={canvasID}
        />
      </RenderPolygonBasedStatementDetails>
    );
  },
  areEqual,
);

const ElementDetailsContainerOCR = ({
  elementList,
  scale,
  clearSelection,
  isPreviewPage,
  BLOCK,
  markerDisplayValue,
  calloutDisplayValue,
  sectionId,
  showElementStatusAndFlag = true,
  isLeftView,
  canvasID,
}) => {
  const position = useSelector(
    (store) => store?.data?.statementSummary?.annotationPosition?.position,
  );
  const isCftEnabled = useSelector(
    (store) => store?.data?.selectedStatement?.isCftEnabled,
  );

  return (
    <>
      {elementList.length > 0 &&
        elementList
          .filter((element) => element.isIncluded)
          .map((element) => (
            <ElementDetailsWrapper
              key={element.id}
              element={element}
              scale={scale}
              BLOCK={BLOCK}
              markerDisplayValue={markerDisplayValue}
              calloutDisplayValue={calloutDisplayValue}
              clearSelection={clearSelection}
              showElementStatusAndFlag={showElementStatusAndFlag}
              sectionId={sectionId}
              isPreviewPage={isPreviewPage}
              isLeftView={isLeftView}
              canvasID={canvasID}
              position={position}
              isCftEnabled={isCftEnabled}
            />
          ))}
    </>
  );
};

export default React.memo(ElementDetailsContainerOCR);
